import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./action";
import getters from "./getters";

Vue.use(Vuex);
const state = {
  userInfo: "",
  hadLog: false,
  slogn: "酒店之外 就住小猪<br>覆盖全球700+个目的地",
  isLoading: false,
  typeKey: 1,
  mainUrl: location.protocol + "//" + location.hostname,
  calendarInfo: "",
  hasAbordCity: "",
  setData: "",
  isRequest: false,
  showChatAction: false, // 消息 复制 删除弹层
  needsCheck: false
};
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js